"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.agColId = exports.isRootCol = exports.isEmptyScopeCol = exports.isScopeCol = exports.isSeriesCol = exports.isSliceCol = exports.ColumnGroupingDescriptorId = void 0;
exports.ColumnGroupingDescriptorId = "root";
function isSliceCol(obj) {
    var _a;
    return ((_a = obj) === null || _a === void 0 ? void 0 : _a.type) === "sliceCol";
}
exports.isSliceCol = isSliceCol;
function isSeriesCol(obj) {
    var _a;
    return ((_a = obj) === null || _a === void 0 ? void 0 : _a.type) == "seriesCol";
}
exports.isSeriesCol = isSeriesCol;
function isScopeCol(obj) {
    var _a;
    return ((_a = obj) === null || _a === void 0 ? void 0 : _a.type) === "scopeCol";
}
exports.isScopeCol = isScopeCol;
/**
 * Tests whether the provided col is a {@link ScopeCol} with no children - which implies that it is the bottom
 * most group that is not linked to any measure columns, which in turn means the table is not defined with any measures.
 *
 * @param col - col to test
 */
function isEmptyScopeCol(col) {
    return isScopeCol(col) && col.children.length === 0;
}
exports.isEmptyScopeCol = isEmptyScopeCol;
function isRootCol(obj) {
    var _a;
    return ((_a = obj) === null || _a === void 0 ? void 0 : _a.type) === "rootCol";
}
exports.isRootCol = isRootCol;
function isColDef(obj) {
    var _a;
    return ((_a = obj) === null || _a === void 0 ? void 0 : _a.colId) !== undefined;
}
function isColumn(obj) {
    var _a;
    return ((_a = obj) === null || _a === void 0 ? void 0 : _a.getColDef) !== undefined;
}
/**
 * Convenience accessor of ag-grid column identifier. This can take either string itself or the
 * different type of col flying around ag-grid API (ColDef, ColGroupDef or Column).
 *
 * For purposes of our table, column ID for ag-grid groups is the groupId.
 *
 * @param colOrId - column id (returned as is) or one of the ag-grid's column types
 */
function agColId(colOrId) {
    if (typeof colOrId === "string") {
        return colOrId;
    }
    if (isColDef(colOrId)) {
        return colOrId.colId;
    }
    else if (isColumn(colOrId)) {
        return agColId(colOrId.getColDef());
    }
    else {
        return colOrId.groupId;
    }
}
exports.agColId = agColId;
//# sourceMappingURL=tableDescriptorTypes.js.map